module.exports = __webpack_public_path__ + "h5-static/img/asign_rules.b15f6c7a.png";